module.exports = __webpack_public_path__ + "media/components/map/marker-images/pause-icon-2x-24d4331854add0cac685221c7093755e.png";